import PropTypes from "prop-types"

import { PageTitle } from "@jewlr/storybook/info"

import Breadcrumb from "./breadcrumb"

const InfoLayoutNew = ({
  breadcrumbItems = [],
  children,
  heading,
  hidePageTitle,
  isNewDesign,
  title,
}) => (
  <>
    <div className="contained">
      <Breadcrumb subitems={breadcrumbItems} title={heading || title} />
      {!hidePageTitle && (
        <PageTitle isNewDesign={isNewDesign}>{heading || title}</PageTitle>
      )}
    </div>
    {children}
  </>
)

InfoLayoutNew.propTypes = {
  breadcrumbItems: PropTypes.array,
  children: PropTypes.element.isRequired,
  heading: PropTypes.string,
  hidePageTitle: PropTypes.bool,
  isNewDesign: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default InfoLayoutNew
